
import React, { Component, ReactNode, SyntheticEvent } from 'react';
import { FormGroup } from '../component/form';
import { Loading } from '../component/BaseComponent';
import { HttpsRequest, Session, ProductName } from '../component/Utils';
import { AiOutlineCheckSquare } from "react-icons/ai";
import {Link } from 'react-router-dom'; 
import {APIRoute, APPRoute} from '../component/texts';


type ProfileData = {
  token: string;
  email: string;
  username: string;
  custype: string;
  company: string;
  maptoken: string;
  lat: string;
  lng: string;
  map_type: number;
  account_type: number;
  movehistory: number;
  menu: Record<string, string>;
}

export const SideView = () => {

  return (<div className="col-md-5  padh5 box sticky-top d-sm-none d-none d-md-block"
  style={{ height: "100vh" }}>
  <div className="padv10 mt5 mbt5">
    <h1 className="bgtext white-text montsert-bold"> <ProductName size='50px' classname='white-text' /> </h1>
    <p className="white-text  montsert-reg"> tracking, logistics and fleet management </p>
  </div>

  <div style={{ width: '100%' }}>
    <div>
      <h2 className='white-text monsert-reg'>
         Features 
      </h2>
      <ul className='white-text monsert-reg nodecor' style={{fontSize: '1em'}}>
        <li> <AiOutlineCheckSquare size={30} /> &nbsp; Multiple tracker support </li>
        <li> <AiOutlineCheckSquare size={30} /> &nbsp; Custom Tracker Data Access Via Our API/SDK </li>
        <li> <AiOutlineCheckSquare size={30} /> &nbsp; Fleet Management and monitoring </li>
        <li> <AiOutlineCheckSquare size={30} /> &nbsp; Fuel Tank Telemetry </li>
        <li> <AiOutlineCheckSquare size={30} /> &nbsp; Logistics tracking and delivery management system </li>
      </ul>
      <div>
          <br />
          <br />
          <p className='white-text monsert-reg'> Now on Android store </p>
          <a target="_blank" href="https://play.google.com/store/apps/details?id=com.maptrackappmain"> 
            <img src="https://storageloc.s3.eu-north-1.amazonaws.com/google_play.png" alt="Android App Download link"/>   
             &nbsp;
            <img style={{width: "50px", height: "50px", borderRadius: "10px"}} src="https://storageloc.s3.eu-north-1.amazonaws.com/playstore.png" alt=""/>
          </a> 
          <br></br>
      </div>
    </div>
  </div>
</div>
  )
}

export const MainViewWrapper = ({children}: {children: ReactNode}) => {
  const year = new Date().getFullYear();


  return (
    <div>
        <div className='center d-lg-none d-md-none d-sm-block mb-5'> 
            <ProductName size='40px' classname='logo_title' />
            <p>
              tracking, logistics and fleet management
            </p>
        </div>
        <br />

        {children}
        <br />
        <div className='center d-lg-none d-md-none d-sm-block'> 
            <br />
            <p className='white-text monsert-reg'> Now on Android store </p>
            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.maptrackappmain"> 
            <img src="https://storageloc.s3.eu-north-1.amazonaws.com/google_play.png" alt="Android App Download link"/>   
            &nbsp;
            <img style={{width: "50px", height: "50px", borderRadius: "10px"}} src="https://storageloc.s3.eu-north-1.amazonaws.com/playstore.png" alt=""/>
            </a> 
            <br />
            <br /> 
        </div>
        <p className='center text-muted'>
            powered by <a href="https://www.ecardex.com/" className='nodecor' target='_blank'> Ecardex Limited </a> &copy; 2020 - {year}
        </p>
    </div>


  )
}


class LoginView extends Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      form: [],
      isbusy: true,
      data: {},
      redirect: false
    };

  }

  render() {

    

    return (<div className="row posrel">
      
      <SideView /> 

      <div className="col-md-6 mbt10">

        <MainViewWrapper> 
        <div className="padh10 mt10">

          <div className='mbt10'>
            
            

            <div className="d-flex justify-content-between align-items-center">
                <h3> Login </h3>           
                <Link to={APPRoute.signup} className='nodecor'>              
                  <span className='text-muted'> Don't have an account? </span> &nbsp; Sign Up
                </Link>
            </div>
             
          </div>

          <form method='post' autoComplete="off" onSubmit={this.submit_data}>
            {
              this.state.form.map((fld, idx) => {
                return <FormGroup
                  key={`logn${idx}`}
                  obj={fld} onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    this.onchange(e);
                    // TODO: implement a clear error handler for the inputs
                  }}
                />;
              })
            }


            <Link to={APPRoute.password_confirm} className='btn btn-link nodecor'>              
              forgot password
            </Link>
            
            <div className="mb-4 mt-4 padv5">
              <div className="d-grid">
                <button type="submit" className="btn btn-primary btn-lg">
                  Sign In
                </button>
              </div>
            </div>
          </form>
          
        </div>
        </MainViewWrapper>
      
      </div>
      
      {this.state.isbusy && <Loading />}
    </div>
    );
  }

  initfunc = () => {
    HttpsRequest.get(APIRoute.login, this.get_resp);
  }

  get_resp = ({ body }: RespArgs) => {

    this.setState({
      form: body['form'],
      isbusy: false
    });

  }

  componentDidMount() {
    this.initfunc();
    const search = window.location.hash.split('?')[1]
    if (search !== undefined) window.location.reload();
    
  }

  submit_data = (event: SyntheticEvent<HTMLFormElement>) => {
    event.preventDefault();
    const { data } = this.state;
    HttpsRequest.post(APIRoute.login, data, this.post_resp);
    this.setState({ isbusy: true });

  }

  post_resp = (resp: RespArgs) => {

    if (resp.status === 0) {
      const data = resp.body as ProfileData

      Session.save('token', data.token);
      Session.save('email', data.email);
      Session.save('username', data.username);
      Session.save('custype', data.custype);
      Session.save('company', data.company);
      Session.save('maptoken', data.maptoken);
      Session.save("lat_center", data.lat);
      Session.save("lng_center", data.lng);
      Session.save("map_type", `${data.map_type}`);
      Session.save("account_type", `${data.account_type}`);
      Session.save("max_history_count", `${data.movehistory}`);
      Session.save('menu', JSON.stringify(data.menu));

      return this.props.navigate(APPRoute.map)

    }

    this.setState({
      form: resp.body['form'],
      isbusy: false
    });

  }

  onchange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {

    const name: string = target.name;
    const value: string = target.value;
    const checked: boolean = target.checked;
    const type: string = target.type;

    if (type === 'checkbox') {
      this.setState({ data: Object.assign({}, this.state.data, { [name]: checked }) });
      return;
    }

    this.setState({ data: Object.assign({}, this.state.data, { [name]: value }) });

  }
}


export default LoginView; 